import React, { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
import { Card, CardBody, Container, Row } from "reactstrap"
import axios from "axios"
import Spinners from "components/Common/Spinner"
const Home = () => {
  const [Loading, setLoading] = useState(false)
  const { id } = useParams()
  const token = localStorage.getItem("Token").replace(/"/g, "")
  const [channel, setChannel] = useState()
  const getvideoChannel = async () => {
    try {
      setLoading(true)
      axios({
        method: "POST",
        url: "https://marcopolo.prisms.in/api/youtube/get-channelwise-video",
        data: {
          channel_id: id,
        },
        headers: {
          Authorization: token,
        },
      }).then(res => {
        setChannel(res.data.data)
        setLoading(false)
      })
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    getvideoChannel()
  }, [token, id])

  if (Loading) {
    return <Spinners />
  }

  if (!channel || channel.length === 0) {
    return (
      <Row className="my-5 py-4 text-center mt-5">
        <CardBody>
          <Card>
            <h1 className="text-center mt-2 fs-4">Videos not available</h1>
          </Card>
        </CardBody>
      </Row>
    )
  }
  return (
    <Row className="mt-5 py-4">
      <Container>
        <CardBody>
          <Card>
            <ul className="list-group list-group-flush">
              {channel &&
                channel.map((item, index) => {
                  const videoId = item.link.split("v=")[1]?.split("&")[0]
                  const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/0.jpg`

                  return (
                    <a
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      key={index}
                      className="text-decoration-none"
                    >
                      <li className="list-group-item  text-white text-center d-flex flex-column align-items-center">
                        <img
                          src={thumbnailUrl}
                          alt="YouTube thumbnail"
                          style={{
                            width: "350px",
                            height: "150px",
                            border: "5px",
                            marginBottom: "10px",
                          }}
                        />
                      </li>
                    </a>
                  )
                })}
            </ul>
          </Card>
        </CardBody>
      </Container>
    </Row>
  )
}

export default Home
